import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { from, of } from 'rxjs';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { fromApiEffectSwitchMap } from '@lib';
import {
  cancelGetFlightsResultRequest,
  failGetFlightsResult,
  setGetFlightsResult,
  setGetFlightsResultFromApi,
  updateGetFlightsResult,
  updateGetFlightsResultFromApi,
} from './get-flights-result.actions';

/**
 * Service to handle async GetFlightsResult actions
 */
@Injectable()
export class GetFlightsResultEffect {
  /**
   * Set the state with the reply content, dispatch failGetFlightsResult if it catches a failure
   */
  public setFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(setGetFlightsResultFromApi),
      fromApiEffectSwitchMap(
        (reply, action) => setGetFlightsResult({ model: reply, requestId: action.requestId }),
        (error, action) => of(failGetFlightsResult({ error, requestId: action.requestId })),
        cancelGetFlightsResultRequest
      )
    )
  );

  /**
   * Update the state with the reply content, dispatch failGetFlightsResult if it catches a failure
   */
  public updateFromApi$ = createEffect(() =>
    this.actions$.pipe(
      ofType(updateGetFlightsResultFromApi),
      mergeMap((payload) =>
        from(payload.call).pipe(
          map((reply) => updateGetFlightsResult({ model: reply, requestId: payload.requestId })),
          catchError((err) => of(failGetFlightsResult({ error: err, requestId: payload.requestId })))
        )
      )
    )
  );

  constructor(protected actions$: Actions) {}
}
